import React from "react";
import Section from "./Section";
import * as content from "../content";

export default function Schedule() {
  const { schedule: s } = content;
  return (
    <Section id="schedule">
      <h2 className="section-title">{s.heading}</h2>
      {s.days.map((day) => (
        <div key={day.dateLabel} className="schedule-day">
          <h3 className="schedule-day__title">{day.dateLabel}</h3>
          {day.intro ? <p className="prose schedule-day__intro">{day.intro}</p> : null}
          <ol className="schedule-blocks">
            {day.blocks.map((block, i) => (
              <li key={`${day.dateLabel}-${i}`} className="schedule-block">
                <p className="schedule-block__time">{block.time}</p>
                <div className="schedule-block__body">
                  {block.title ? <p className="schedule-block__title">{block.title}</p> : null}
                  {block.mapUrl ? (
                    <p className="prose schedule-block__map-link">
                      <a href={block.mapUrl} target="_blank" rel="noopener noreferrer">
                        {`@ ${block.mapLabel || "Location"}`}
                      </a>
                    </p>
                  ) : null}
                  {block.extraMapLinks?.map((link) => (
                    <p key={link.url} className="prose schedule-block__map-link">
                      <a href={link.url} target="_blank" rel="noopener noreferrer">
                        {`@ ${link.label}`}
                      </a>
                    </p>
                  ))}
                  {block.detail ? (
                    <p className="prose schedule-block__detail">{block.detail}</p>
                  ) : null}
                </div>
              </li>
            ))}
          </ol>
        </div>
      ))}
    </Section>
  );
}
